import { Card, CardContent, Skeleton, Typography } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';

export function BasicSupportSkeleton() {
  return (
    <Row className='mb-4'>
      <Col md={6} xxl={3}>
        <Card sx={{ minHeight: 134 }} className='mb-4'>
          <CardContent>
            <div className="d-flex flex-row align-items-center mb-3">
              <Skeleton className='me-3' variant="circular" width={40} height={40} />
              <Typography
                variant="h5"
                component="div">
                <Skeleton animation="wave" width={100} />
              </Typography>
            </div>
            <Typography
              variant="h6"
              component="div" className='me-2'>
              <Skeleton animation="wave" width={150} />
            </Typography>
            <Typography
              variant="h6"
              component="div">
              <Skeleton animation="wave" width={150} />
            </Typography>
          </CardContent>
        </Card>
      </Col>

      <Col md={6} xxl={3}>
        <Card sx={{ minHeight: 134 }} className='mb-4'>
          <CardContent>
            <div className="d-flex flex-row align-items-center mb-3">
              <Skeleton className='me-3' variant="circular" width={40} height={40} />
              <Typography
                variant="h5"
                component="div"
                className="mb-3">
                <Skeleton animation="wave" width={100} />
              </Typography>
            </div>
            <Typography
              variant="h6"
              component="div">
              <Skeleton animation="wave" width={150} />
            </Typography>
          </CardContent>
        </Card>
      </Col>

      <Col md={6} xxl={3}>
        <Card sx={{ minHeight: 134 }} className='mb-4'>
          <CardContent>
            <div className="d-flex flex-row align-items-center mb-3">
              <Skeleton className='me-3' variant="circular" width={40} height={40} />
              <Typography
                variant="h5"
                component="div"
                className="mb-3">
                <Skeleton animation="wave" width={100} />
              </Typography>
            </div>
            <Typography
              variant="h6"
              component="div">
              <Skeleton animation="wave" width={150} />
            </Typography>
            <Typography
              variant="h6"
              component="div">
              <Skeleton animation="wave" width={150} />
            </Typography>
          </CardContent>
        </Card>
      </Col>

      <Col md={6} xxl={3}>
        <Card sx={{ minHeight: 134 }} className='mb-4'>
          <CardContent>
            <div className="d-flex flex-row align-items-center mb-3">
              <Skeleton className='me-3' variant="circular" width={40} height={40} />
              <Typography
                variant="h5"
                component="div"
                className="mb-3">
                <Skeleton animation="wave" width={100} />
              </Typography>
            </div>
            <Typography
              variant="h6"
              component="div">
              <Skeleton animation="wave" width={150} />
            </Typography>
            <Typography
              variant="h6"
              component="div">
              <Skeleton animation="wave" width={150} />
            </Typography>
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
}

export default BasicSupportSkeleton;
